<template>
  <html>

  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no" />
    <meta name="mobile-web-app-capable" content="yes" />
    <meta name="apple-mobile-web-app-capable" content="yes" />
    <link rel="icon" type="image/png" href="favicon.png" />
    <title>Restó APP</title>
  </head>

  <body class="home-page">
    <Header :isRestoCompleto=true ></Header>
    <div class="col-lg-12 mx-auto p-3 py-md-5">
      <main>
        <div class="row">
        <div class="col-lg-4">

        <div class="pricing-header" style="text-align: initial;">
      
      <h4 class="" style="margin-bottom: 0px;">Mis Stock de Reservas</h4>
      <h6 class="" style="margin-bottom: 0px;" >Cantidad de reservas disponibles:</h6>
      <p class="" style="margin-bottom: 0px;" >Cantidad {{ cantidadVencer }} a vencer</p>
      <p class=""  >Cantidad {{cantidadSinVencer}} sin vencimiento</p>
      <button class="btn btn-primary" v-on:click="goToTienda()">Comprar mas paquetes</button>
    
      <h6 class="" style="margin-bottom: 0px;">Detalle de movimientos de stock de reservas</h6>
    </div>
  </div>

  <div class="col-lg-8">

   
  <input type="text" class="form-control" placeholder="Buscar movimiento" v-model="busqueda" aria-label="Buscar movimiento" aria-describedby="button-addon2">
  <button type="button" class="btn btn-primary"  v-on:click="buscar(1)" >Buscar</button>


</div>


</div>

        <hr class="" />

        <table class="table table-responsive table-striped align-middle">
          <thead>
            <tr>
              <th scope="col">Fecha Hora</th>
              <th scope="col">Tipo de movimiento</th>
              <th scope="col">Observaciones</th>
              <th scope="col">Cantidad</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="filtrados.length == 0">
              <td colspan="11">
                <h4 class="text-center">Sin datos</h4>
              </td>
            </tr>
            <tr v-for="(compra, index) in filtrados" :key="index">
              <td scope="row">{{ compra.fecha }}</td>
              <td scope="row">{{ compra.tipoMovimiento }}</td>
              <td scope="row">{{ compra.observacion }}</td>
              <td scope="row">{{ compra.cantidad }}</td>
              
            </tr>
          </tbody>
        </table>

        <div class="row">

<div class="col-3">


  <div class="input-group mb-3">
<label class="input-group-text" for="inputGroupSelect01">Resultados por pagina: &nbsp;</label>
<select
    v-model="pageSizeSelected"
    @change="buscar(currentPage)"
    class="form-select"
  >
    <option value="5">5</option>
    <option value="10">10</option>
    <option value="15">15</option>
    <option value="20">20</option>
    <option value="25">25</option>
    <option value="-1">Todos</option>
  </select>
</div>

</div>

<div class="col-5">
  <b-pagination
    v-model="currentPage"
    :total-rows="totalRows"
    :per-page="pageSize"
    @change="buscar($event)"
    last-number
  ></b-pagination>
</div>
<div class="col-3">
                  <h6> <b>Total resultados: {{ this.totalRows }} </b></h6>
                </div>

</div>


<PopUpSinCerrar :show="cargando">
              <template #body>
                <p>{{ cargando_msg }}</p>
              </template>
            </PopUpSinCerrar>

      </main>
      <Footer />
    </div>
  </body>

  </html>
</template>

<script>
import axios from "axios";

import "vue2-datepicker/index.css";
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import PopUpSinCerrar from "../components/PopUpSinCerrar.vue";
export default {
  name: "MiStock",
  components: { Header, Footer ,PopUpSinCerrar },
  data: function () {
    return {
      filename: "",
      fechaRegistro: "",
      fechaReserva: "",
      estados: [],
      estadoSelec: "",
      email: "",
      telefono: "",
      compras: [],
      filtrados: [],
      error: false,
      error_msg: "",
      success: false,
      success_msg: "",
      currentPage: 1,
      pageSize: 10,
      pageSizeSelected: 10,
      totalRows: 0,
      cargando_msg:"",
      cargando:false,
      busqueda:"",
      cantidadVencer:0,
      cantidadSinVencer:0,
    };
  },
  methods: {
    goToTienda() {
      this.$router.push({ name: 'tienda'});
    },
    cargarStock(){


axios
.get("/getStockReservas")
.then((data) => {
if (data.status == 200) {
 this.cantidadSinVencer=data.data.cantidadSinVencer;
 this.cantidadVencer=data.data.cantidadVencer;
}
})
.catch(() => {
this.error = true;
this.error_msg =
  "No se ha podido actualizar la informacion. Vuelva a intentar mas tarde";
});
},
validarPaquetes(){


axios
.get("/mp/preferencia-pendiente")
.then(() => {

})
.catch(() => {
this.error = true;
this.error_msg =
"No se ha podido actualizar la informacion. Vuelva a intentar mas tarde";
});



},
    buscar($page) {


      this.cargando = true;
        this.cargando_msg =
          "Buscando compras";


      let request = {
        size: this.pageSizeSelected,
        page: $page - 1,
        busqueda:this.busqueda
      };

      

      this.filtrados = [];
    
      axios.get("/movimiento-stock"+ "?" +
                  this.convertDataObjectUrl(request)).then((data) => {
                    this.cargando=false;
      if (data.status == 200) {
       

        if(this.pageSizeSelected==-1){
                    this.pageSize=data.data.length
                  }else{
                    this.pageSize=this.pageSizeSelected
       }

        this.compras = data.data.items;
        this.filtrados = data.data.items;
         this.totalRows = data.data.total;

                  
      } else {
        this.error = true;
        this.error_msg =
          "No se ha podido buscar las reservas. Vuelva a intentar mas tarde";
      }
    });
    },
    convertDataObjectUrl(data) {
      return Object.keys(data)
        .map(function (k) {
          return encodeURIComponent(k) + "=" + encodeURIComponent(data[k]);
        })
        .join("&");
    },
  },

  beforeMount() {
    this.cargarStock();
   this.buscar(1);
   this.validarPaquetes()
    
  },
};
</script>

<style scoped>
@import url("https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap");

:host {
  --main-color: #0047b3;
  --second-color: #0198f3;
  --grey-color: #f5f8fa;
  --border-radius-1: 9px;
  --border-radius-2: 6px;
}

body {
  font-family: "Inter", sans-serif;
  color: #083744;
  font-size: 14px;
  height: 100%;
}
</style>
